var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-picker"},[_c('DatePicker',{attrs:{"righttoleft":"true","initRange":_vm.initRange},on:{"closed":_vm.onClosed,"selected":_vm.onDateSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }